import { environment } from '../../../../../environments/environment';
import { CoreStore } from '../../../../core/store/core.store';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { hasAccessToBusinessCenter, hasAccessToCustomerPortal, hasAccessToPartnerPortal } from '@ppl/auth';


@Component({
  selector: 'ppl-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class DashboardComponent {
  crmLink = environment.crmAppUrl;
  businessCenterLink = environment.businessCenterUrl;
  customerPortalLink = environment.customerPortalUrl;
  partnerPortalLink = environment.partnerPortalUrl;

  hasAccessToBusinessCenter$ = this.store.select(hasAccessToBusinessCenter);
  hasAccessToCustomerPortal$ = this.store.select(hasAccessToCustomerPortal);
  hasAccessToPartnerPortal$ = this.store.select(hasAccessToPartnerPortal);

  constructor(
    private store: CoreStore
  ) { }
}
